import { JsonObject } from 'json2typescript';
import { SimulationObjInterface } from '../interfaces/simulation-obj.interface';

@JsonObject('SimulationObjModel')
export class SimulationObjModel implements SimulationObjInterface {
  Id?: string;
  Name?: string;
  Currency?: string;
  ProfileId?: number;
  GoalAmount?: number;
  TimeHorizon?: number;
  Inflation?: number;
  InitialContributionAmount?: number;
  PeriodicContributionAmount?: number;
  PeriodicContributionFrequency?: string;
  WithdrawlTimeHorizon?: number;
  Taxes?: number;
  AnnualIncomes?: number;
  LivingStandards?: number;
  SocialSecurityIncomePerc?: number;
  Type?: string;
  Priority?: number;
  InitialDate?: string;//Date;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
